import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, ROW_COUNT, API_ADMIN_TIPO_AUDITORIA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { ITipoAuditoria } from "../../../entities/ITipoAuditoria";

const TipoAuditoria = () => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<ITipoAuditoria>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);
        setListItems(result.result.data);
      })
      .catch((error) => {});
  };
  const edit = (value: ITipoAuditoria, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }

    postAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID !== undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              NOMBRE: "string",
              ACTIVO: false,
              ES_GLOBAL: false,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
            },
            {}
          );
          filter(false as unknown as Partial<ITipoAuditoria>, false, 1);
        }}></button>
      <AdminLista
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"TipoAuditoria"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Tipo Auditoría"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default TipoAuditoria;
